<template>
  <jt-card-default class="container"
    @filter-button="openModalFilter"
  >
    <div v-if="isLoadingDoughnut" class="div-loader">
      <div class="spinning-loader rotate"></div>
    </div>
      <jt-doughnut-chart
        v-else
        :centralTitleConst="$gettext('RESIDUE')"
        :data="doughnutData"
        :shouldShowLegend="true"
        :shouldShowLabelParts="false"
        :shouldShowValueInLabelParts="false"
        :shouldShowPercentageInLabelParts="true"
      />
      <technology-dashboard-modal-filter
        v-if="modalData.show"
        v-bind="modalData"
        @submit="onChangeSelectDoughnut"
        @change-visibility="(show) => (modalData.show = show)"
    />
  </jt-card-default>
</template>
<script>
import JtDoughnutChart from 'src/components/charts/JtDoughnutChart.vue'
import JtCardDefault from './base/JtCardDefault.vue'
import { Component, Vue } from 'vue-property-decorator'
import { repository } from 'jtech'
import TechnologyDashboardModalFilter from './base/TechnologyDashboardModalFilter.vue'

@Component({
  name: 'ResiduesByTechnologyPizzaGraph',
  components: {
    JtCardDefault,
    JtDoughnutChart,
    TechnologyDashboardModalFilter
  }
})
export default class ResiduesByTechnologyPizzaGraph extends Vue {
  isLoadingDoughnut = false;

  modalData = {
    show: false
  }

  doughnutData = [];
  currentDate = {
    date: new Date()
  };

  async created () {
    await this.onChangeSelectDoughnut(this.currentDate)
  }

  async openModalFilter () {
    this.modalData = {
      show: true
    }
  }

  async onChangeSelectDoughnut (newValue) {
    this.isLoadingDoughnut = true
    this.doughnutData = await this.getDoughnutData(newValue)

    setTimeout(() => {
      this.isLoadingDoughnut = false
    }, 500)
  }

  async getDoughnutData (form) {
    const objectRequest = {
      month: form.date.getMonth() + 1,
      year: form.date.getFullYear(),
      composition: [{
        technologies: form.technologies,
        residues: form.residues
      }]
    }
    const { registros } = await repository.resolveLogic('technologyDashboard.searchTicketsGroupByResidues', { ...objectRequest })
    return registros.map((registro) => {
      return {
        label: registro.residueName,
        value: (registro.value / 1000).toFixed(2)
      }
    })
  }
}
</script>

<style  scoped lang="stylus">
@import '~quasar-variables';

.container {
  width: 100%;
  height: 100%;
}
</style>
